import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import './index.css';
import App from './App';
import { initializeAPI } from './services/api';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize global API interceptors and error handling before app renders
initializeAPI();

root.render(
  <React.StrictMode>
    <HashRouter>
      <CssBaseline />
      <App />
    </HashRouter>
  </React.StrictMode>
); 
